// extracted by mini-css-extract-plugin
export default {"root":"LabelRangeSlider_root__ihv9x"};